import React, { useState, useEffect, useMemo } from 'react'
import Swal from 'sweetalert2'
import { useHistory } from 'react-router'
import { Container, Grid, TextField, Button } from '@material-ui/core'
import { Autocomplete } from '@mui/material';
import { settingAPI } from './../services/SettingService'
import { Formik, Form } from 'formik'
import { useDropzone } from "react-dropzone";

const Setting_Create_Template = () => {
    let history = useHistory()
    const token = localStorage.getItem("Token")
    const [type, setType] = useState([])
    const [force, setForce] = useState(0)
    const [Type_Name, setType_Name] = useState("")
    const [GoogleDrive, SetGoogleDrive] = useState(false)

    useEffect(() => {
        let id = document.getElementById("root")
        document.title = `Com7 Merchandise - สร้างไฟล์ Template`
        if (id) {
            id.style.height = "auto"
        }
        settingAPI.GetType(token)
            .then((res) => {
                if (res.status == 200) {
                    if (Array.isArray(res.message)) {
                        setType(res.message)
                    }
                }
                else {
                    Swal.fire({
                        icon: 'error',
                        confirmButtonColor: "#f27474",
                        html: `<span class="colorWhite">${res.message}</span>`,
                        backdrop: 'transparent',
                        background: 'rgba(0,0,0,.75)',
                        customClass: {
                            icon: 'switch'
                        },
                        width: '28rem',
                        timer: 10000
                    }).then(() => {
                        setForce((old) => old + 1)
                    })
                }
            })
            .catch((error) => {
                Swal.fire({
                    icon: 'error',
                    confirmButtonColor: "#f27474",
                    html: `<span class="colorWhite">${error.message}</span>`,
                    backdrop: 'transparent',
                    background: 'rgba(0,0,0,.75)',
                    customClass: {
                        icon: 'switch'
                    },
                    width: '28rem',
                    timer: 10000
                }).then(() => {
                    setForce((old) => old + 1)
                })
            })
        return () => {
            let id = document.getElementById("root")
            if (id) {
                id.style.height = "97vh"
            }
        }
    }, [force])

    const DropZoneComponents = (props) => {
        const activeStyle = {
            borderColor: "#2196f3",
        };

        const acceptStyle = {
            borderColor: "#00e676",
        };

        const rejectStyle = {
            borderColor: "#ff1744",
        };

        const { setFieldValue } = props

        const {
            acceptedFiles,
            fileRejections,
            getRootProps,
            getInputProps, isDragActive, isDragAccept, isDragReject
        } = useDropzone({
            maxFiles: 5,
            // accept: 'image/jpeg, image/png',
            onDrop: (acceptedFiles) => {
                setFieldValue("template_file_name", acceptedFiles)
            }
        });
        const style = useMemo(
            () => ({
                ...(isDragActive ? activeStyle : {}),
                ...(isDragAccept ? acceptStyle : {}),
                ...(isDragReject ? rejectStyle : {}),
            }),
            [isDragActive, isDragReject, isDragAccept]
        );
        const acceptedFileItems = acceptedFiles.map(file => (
            <li key={file.path}>
                {file.path} - {file.size} bytes
            </li>
        ));

        const fileRejectionItems = fileRejections.map(({ file, errors }) => {
            return (
                <li key={file.path}>
                    {file.path} - {file.size} bytes
                    <ul>
                        {errors.map(e => <li key={e.code}>{e.message}</li>)}
                    </ul>
                </li>
            )
        });

        return (
            <>
                <section className="container uploadBox" {...getRootProps({ style })}>
                    <div {...getRootProps({ className: 'dropzone' })}>
                        <input {...getInputProps()} />
                        <p>เลือกไฟล์หรือลากไฟล์เพื่ออัพโหลดไฟล์ (สูงสุด 5 ไฟล์)</p>
                    </div>
                </section>
                <aside>
                    {acceptedFiles.length >= 1 && <div>
                        <h5>Accepted files</h5>
                        <ul>{acceptedFileItems}</ul>
                    </div>}
                    {fileRejections.length >= 1 && <div>
                        <h5>Rejected files</h5>
                        <ul>{fileRejectionItems}</ul>
                    </div>}
                </aside>
            </>
        );
    }

    return (
        <Formik
            initialValues={{ template_file_name: [], type: null, use: null }}
            onSubmit={async (values, { resetForm, setSubmitting }) => {
                try {
                    if (!values.type) throw { message: "กรุณาเลือก Type" }
                    if (!values.use) throw { message: "กรุณาเลือกกลุ่ม User ใช้งาน" }
                    if (values.template_file_name.length == 0) throw { message: "กรุณาใส่ไฟล์" }
                    setSubmitting(true)
                    let form = new FormData()
                    form.append("type", values.type)
                    form.append("use", values.use)
                    values.template_file_name.map((res, i) => {
                        form.append(`template_file_name${i}`, res)
                    })
                    settingAPI.AddTemplate(token, form)
                        .then((res) => {
                            if (res.status == 200) {
                                Swal.fire({
                                    icon: 'success',
                                    confirmButtonColor: "#6ab23a",
                                    html: `<span class="colorWhite">${res.message}</span>`,
                                    backdrop: 'transparent',
                                    background: 'rgba(0,0,0,.75)',
                                    customClass: {
                                        icon: 'switchZ'
                                    },
                                    width: '28rem',
                                    timer: 3000
                                }).then((res) => {
                                    history.push("/settings/template")
                                    setSubmitting(false)
                                })
                            }
                            else {
                                setSubmitting(false)
                                Swal.fire({
                                    icon: 'error',
                                    confirmButtonColor: "#f27474",
                                    html: `<span class="colorWhite">${res.message}</span>`,
                                    backdrop: 'transparent',
                                    background: 'rgba(0,0,0,.75)',
                                    customClass: {
                                        icon: 'switch'
                                    },
                                    width: '28rem',
                                    timer: 5000
                                })
                            }
                        })
                        .catch((error) => {
                            setSubmitting(false)
                            Swal.fire({
                                icon: 'error',
                                confirmButtonColor: "#f27474",
                                html: `<span class="colorWhite">${error.message}</span>`,
                                backdrop: 'transparent',
                                background: 'rgba(0,0,0,.75)',
                                customClass: {
                                    icon: 'switch'
                                },
                                width: '28rem',
                                timer: 5000
                            })
                        })
                } catch (error) {
                    setSubmitting(false)
                    Swal.fire({
                        icon: 'error',
                        confirmButtonColor: "#f27474",
                        html: `<span class="colorWhite">${error.message}</span>`,
                        backdrop: 'transparent',
                        background: 'rgba(0,0,0,.75)',
                        customClass: {
                            icon: 'switch'
                        },
                        width: '28rem',
                        timer: 10000
                    })
                }
            }}
        >
            {({
                values,
                setFieldValue,
                isSubmitting,
            }) => (
                <Form>
                    <Container style={{ padding: '20px', backgroundColor: '#ffffffbd', borderRadius: '10px' }}>
                        <Grid container spacing={1}>
                            <Grid item xs={12}>
                                <h3><strong>เพิ่มไฟล์ Template</strong></h3>
                            </Grid>
                        </Grid>
                        <Container style={{ paddingTop: '2rem' }}>
                            <div className="row">
                                <div className="pt-5 col-lg-12">
                                    <div className="row">
                                        <div className="mt-4 col-lg-12">
                                            <label>
                                                <strong>Type</strong>
                                            </label>
                                            <Autocomplete
                                                options={type.map((res) => res.type_name)}
                                                onChange={(event, newValue) => {
                                                    setFieldValue("type", newValue)
                                                }}
                                                renderInput={(params) => (
                                                    <TextField {...params} label="Type Select..." variant="standard" value={values?.type || ""} />
                                                )}
                                            />
                                        </div>
                                        <div className="mt-4 col-12">
                                            <label>
                                                <strong>User Use</strong>
                                            </label>
                                            <Autocomplete
                                                options={["All", "Retail", "Support"]}
                                                onChange={(event, newValue) => {
                                                    setFieldValue("use", newValue)
                                                }}
                                                renderInput={(params) => (
                                                    <TextField {...params} label="User Use Select..." variant="standard" value={values?.use || ""} />
                                                )}
                                            />
                                        </div>
                                        <div className="mt-4 col-12">
                                            <DropZoneComponents setFieldValue={setFieldValue} />
                                        </div>
                                        <div className="mt-4 col-12">
                                            <Button variant="contained"
                                                type="submit"
                                                disabled={isSubmitting}
                                                style={{
                                                    border: "2px solid transparent",
                                                    backgroundColor: "#6ab23a",
                                                    borderRadius: "5px",
                                                    color: "white",
                                                    fontSize: "16px",
                                                    textDecoration: "none",
                                                    textTransform: "capitalize",
                                                }}>
                                                Submit
                                            </Button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </Container>
                    </Container >
                </Form>)}
        </Formik>
    )
}

export default Setting_Create_Template